import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import BeachAccessOutlined from "@mui/icons-material/BeachAccessOutlined";
import PersonSearchOutlined from "@mui/icons-material/PersonSearchOutlined";
import CollaborateurSearch from "./components/CollaborateurSearch";
import CongeCard from "./components/CongeCard";

export default function GestionConges() {
    const [selected, setSelected] = useState(null);
    return (
        <Box sx={{ p: { xs: 1.5, md: 2.5 }, display: "flex", flexDirection: "column", gap: 2, maxWidth: 1280, mx: "auto" }}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 2, flexWrap: "wrap" }}>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1.25 }}>
                    <Box sx={{ width: 38, height: 38, borderRadius: "10px", display: "flex", alignItems: "center", justifyContent: "center", background: "#ebf4fb", color: "#03407b" }}>
                        <BeachAccessOutlined />
                    </Box>
                    <Box>
                        <Typography sx={{ fontSize: "1.05rem", fontWeight: 800, color: "#0f172a", lineHeight: 1.2 }}>Gestion des congés</Typography>
                        <Typography sx={{ fontSize: "0.78rem", color: "#64748b" }}>Consultez et ajustez le solde de congés d'un collaborateur</Typography>
                    </Box>
                </Box>
                <Box sx={{ flex: "1 1 360px", maxWidth: 520, ml: { md: "auto" } }}>
                    <CollaborateurSearch onSelect={setSelected} />
                </Box>
            </Box>

            {selected ? (
                <CongeCard collaborateur={selected} />
            ) : (
                <Box sx={{ py: 8, display: "flex", flexDirection: "column", alignItems: "center", gap: 1, textAlign: "center", borderRadius: "14px", background: "#fff", border: "1px solid #e2e8f0" }}>
                    <Box sx={{ width: 72, height: 72, borderRadius: "20px", display: "flex", alignItems: "center", justifyContent: "center", background: "#f0f7fd", color: "#7fb3d3", mb: 1 }}>
                        <PersonSearchOutlined sx={{ fontSize: 38 }} />
                    </Box>
                    <Typography sx={{ fontSize: "1rem", fontWeight: 700, color: "#334155" }}>Choisissez un collaborateur</Typography>
                    <Typography sx={{ fontSize: "0.85rem", color: "#94a3b8", maxWidth: 420 }}>
                        Recherchez-le par son nom ou son email pour voir son solde, ses derniers mouvements et enregistrer des jours posés ou restitués.
                    </Typography>
                </Box>
            )}
        </Box>
    );
}
